import { render, staticRenderFns } from "./TallyMarks.vue?vue&type=template&id=0c652d0a&scoped=true&"
import script from "./TallyMarks.vue?vue&type=script&lang=js&"
export * from "./TallyMarks.vue?vue&type=script&lang=js&"
import style0 from "./TallyMarks.vue?vue&type=style&index=0&id=0c652d0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c652d0a",
  null
  
)

export default component.exports